export const streamDelimiter = '\n---';
export const promptDelimiter = '$:-prompt-@#';
